
const ForgotPasswordPage = () => {
    // const classes = useStyles();

    return (
        <div className="forgotPasswordPage">

        </div>
    );
}

export default ForgotPasswordPage;